<template>
  <section class="breadcrumbs-custom">
    <div class="parallax-container">
      <div class="material-parallax parallax"><img src="/assets/images/breadcrumbs-bg.jpg" alt="" style="display: block; transform: translate3d(-50%, 89px, 0px);"></div>
      <div class="breadcrumbs-custom-body parallax-content context-dark">
        <div class="container">
          <h2 class="breadcrumbs-custom-title">{{ product?.name }}</h2>
        </div>
      </div>
    </div>
    <div class="breadcrumbs-custom-footer">
      <div class="container">
        <ul class="breadcrumbs-custom-path">
          <li><router-link to="/our-menu">Our Menu</router-link></li>
          <li class="active">{{ product?.name }}</li>
        </ul>
      </div>
    </div>
  </section>
  <!-- Single Product-->
  <section class="section section-sm section-first bg-default">
    <div class="container">
      <div class="row row-30">
        <div class="col-lg-6">
          <div class="slick-vertical slick-product">
            <!-- Slick Carousel-->
            <div class="carousel-parent" id="carousel-parent" data-items="1" data-swipe="true" data-child="#child-carousel" data-for="#child-carousel">
              <div class="item">
                <div class="slick-product-figure"><img :src="product?.image_530x480 || '/assets/images/dummy_530_480.webp'" alt="" width="530" height="480" onerror="this.onerror=null;this.src='/assets/images/dummy_530_480.webp';"/>
                </div>
              </div>              
            </div>
            <!-- <div class="slick-slider child-carousel slick-nav-1" id="child-carousel" data-arrows="true" data-items="3" data-sm-items="3" data-md-items="3" data-lg-items="3" data-xl-items="3" data-xxl-items="3" data-md-vertical="true" data-for="#carousel-parent">
              <div class="item">
                <div class="slick-product-figure"><img src="/assets/images/single-product-1-530x480.png" alt="" width="530" height="480"/>
                </div>
              </div>
              <div class="item">
                <div class="slick-product-figure"><img src="/assets/images/single-product-2-530x480.png" alt="" width="530" height="480"/>
                </div>
              </div>
              <div class="item">
                <div class="slick-product-figure"><img src="/assets/images/single-product-3-530x480.png" alt="" width="530" height="480"/>
                </div>
              </div>
            </div> -->
          </div>
        </div>
        <div class="col-lg-6">
          <div class="single-product">
            <h3 class="text-transform-none fw-medium">{{ product?.name }}</h3>
            <div class="group-md group-middle">
              <div class="single-product-price">${{ selectedSkus?.price || product?.base_price }}</div>
              <div class="single-product-rating"><span class="icon mdi mdi-star"></span><span class="icon mdi mdi-star"></span><span class="icon mdi mdi-star"></span><span class="icon mdi mdi-star"></span><span class="icon mdi mdi-star-half"></span></div>
            </div>
            <p v-html="product?.description"></p>
            <hr class="hr-gray-100">
           
            <div
            v-for="sku in product?.skus"
            :key="`${product.id}-${sku.id}`"
            class="mt-2 d-inline-block me-2"
            >
              <button
                  type="button"
                  class="btn btn-sm sku-btn"
                  :class="
                  selectedSkus?.id === sku.id
                      ? 'sku-btn-primary text-white'
                      : 'sku-btn-primary-outline'
                  "
                  @click="selectSku(sku)"
              >
                  {{ sku.attributes.map((a) => a.attribute_value).join(' / ') }}
              </button>
            </div>
      
            <div class="group-xs row mt-2">
              <div class="form-wrap">
                <input v-model="message_on_cake" class="form-input" id="message_on_cake" type="text" name="order_notes"/>
                <label class="form-label" for="message_on_cake">Message On Cake</label>
              </div>
              <div class="form-wrap">
                <input v-model="special_instruction" class="form-input" id="special_instruction" type="text" name="order_notes"/>
                <label class="form-label" for="special_instruction">Special Instruction</label>
              </div>
            </div>
            <div class="group-xs">
              <!-- <div class="product-stepper">
                <input class="form-input" type="number" data-zeros="true" value="1" min="1" max="1000">
              </div> -->
              <div><a class="button button-lg button-secondary button-zakaria" @click="addProductToCart(product)">Add to cart</a></div>
            </div>
            <!-- <hr class="hr-gray-100">
            <div class="group-xs group-middle"><span class="list-social-title">Share</span>
              <div>
                <ul class="list-inline list-social list-inline-sm">
                  <li><a class="icon mdi mdi-facebook" href="#"></a></li>
                  <li><a class="icon mdi mdi-twitter" href="#"></a></li>
                  <li><a class="icon mdi mdi-instagram" href="#"></a></li>
                  <li><a class="icon mdi mdi-google-plus" href="#"></a></li>
                </ul>
              </div>
            </div> -->
          </div>
        </div>        
      </div>
      <section class="section section-xl bg-default text-md-start">
        <div class="container">
          <div class="row row-30 justify-content-center justify-content-xl-between">
            <div class="tabs-custom tabs-horizontal tabs-line" id="tabs-1">
                <!-- Nav tabs-->
                <div class="nav-tabs-wrap">
                  <ul class="nav nav-tabs">
                    <li class="nav-item" role="presentation"><a class="nav-link active" href="#tabs-1-1" data-bs-toggle="tab">Description</a></li>
                    <li class="nav-item" role="presentation"><a class="nav-link" href="#tabs-1-2" data-bs-toggle="tab">Addinational Information</a></li>
                    <li class="nav-item" role="presentation"><a class="nav-link" href="#tabs-1-3" data-bs-toggle="tab">Allergy Advice</a></li>
                  </ul>
                </div>
                <!-- Tab panes-->
                <div class="tab-content">
                  <div class="tab-pane fade show active" id="tabs-1-1">
                    <p v-html="selectedSkus?.description"></p>
                  </div>
                  <div class="tab-pane fade" id="tabs-1-2">
                    <cake-additional-info />
                  </div>
                  <div class="tab-pane fade" id="tabs-1-3">
                    <h3>Nuts and Dairy</h3>
                    <p>Please note our Nut-free and Dairy-free cakes are baked and finished on the same premises as nuts and dairy cakes, so may contain traces of them. We are careful to avoid cross contamination by using separately assigned ovan deck, utencils, mixers and tongs to handle anything with nuts and dairy.</p>
                    <p>For Vegan Cake allergy advice please click here</p>
                  </div>
                </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </section>
</template>
<script setup>
import { api } from "@/plugins/axios";
import { onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import { useCartStore } from "@/stores/cart";
import CakeAdditionalInfo from "@/components/CakeAdditionalInfo.vue";
import router from "@/router";

const cartStore = useCartStore()
const route = useRoute()
const product = ref(null)
const selectedSkus = ref({})
const message_on_cake = ref('')
const special_instruction = ref('')

function selectSku(sku) {
  selectedSkus.value = sku
}

onMounted(async () => {
  cartStore.loadCart()

  const scriptId = 'script-js-script'

  // Check if the script already exists
  const existingScript = document.getElementById(scriptId)

  if (existingScript) {
      // Replace it: remove and re-add
      existingScript.remove()
  }

  // Create and append a fresh script
  const newScript = document.createElement('script')
  newScript.src = '/assets/js/script.js'
  newScript.id = scriptId
  document.body.appendChild(newScript)  
  
  await getProduct()

  selectedSkus.value = product.value?.skus?.[0] || {}
})

async function getProduct() {
  await api.get(`/${route.params.category_slug}/${route.params.product_slug}`).then((response) => {
    product.value = response.data.results
  })
}

function addProductToCart(product) {  
  let sku_varient = selectedSkus.value.attributes.map((a) => a.attribute_value).join(' / ')  
  let cartItem = {
    product_id: product.id,
    product_sku_id: selectedSkus.value.id,
    name: `${product.name} - ${sku_varient}`,
    slug: `${product.category_slug}/${product.slug}`,
    price: selectedSkus.value.price,
    image: product.image_187x155,
    message_on_cake: message_on_cake.value,
    special_instruction: special_instruction.value,
    is_chocolate_plaque: product.is_chocolate_plaque,
    chocolate_plaque_price: product.chocolate_plaque_price
  }
  cartStore.addToCart(cartItem)
  setTimeout(() => {
    router.push('/checkout')
  }, 3000)
}
</script>